const objectPath = require("object-path");
let HttpService = require('../Managers/HttpService');

let Config = HttpService.getConfigForHost();
module.exports = {
    set: function(key, value) {

        if (value === undefined) {
            return false;
        }

        let newKV = {
            'question': key,
            'answer': value
        };

        let a = JSON.parse(window.localStorage.getItem("answers"));

        if (a === null) {
            a = new Array();
        }

        let found = false;
        for (let i in a) {
            if (a[i].question == key) {
                a[i].answer = value;
                found = true;
                window.localStorage.setItem('answers', JSON.stringify(a));
            }
        }

        if (found === false) {
            a.push(newKV);
            window.localStorage.setItem('answers', JSON.stringify(a));
        }

    },

    cacheQuote: function(quote) {
        this.clearQuoteCaches();
        window.localStorage.setItem('quote', JSON.stringify(quote));
    },

    /**
     * given a retrieval, get everything into local storage to
     * simulate a completed journey
     * @param  {[type]} quoteAnswers   [description]
     * @param  {[type]} quoteQuoteData [description]
     * @return {[type]}                [description]
     */
    mountQuote : function(quoteAnswers, quoteQuoteData) {
        if (quoteAnswers.dec_BANKRUPTCY == 'yes'
            && quoteAnswers.dec_CONVICTION == 'yes'
            && quoteAnswers.dec_SPECIAL_TERMS == 'yes') {
            quoteAnswers.multi_declaration_1 = 'yes';
        }
        if (quoteAnswers.dec_BANKRUPTCY == 'no'
            && quoteAnswers.dec_CONVICTION == 'no'
            && quoteAnswers.dec_SPECIAL_TERMS == 'no') {
            quoteAnswers.multi_declaration_1 = 'no';
        }

        // second multi dec question - ensure mounts correctly
        if (quoteAnswers.dec_SPECIAL_TERMS == 'yes') {
            quoteAnswers.multi_declaration_1_b = 'yes';
        }
        if (quoteAnswers.dec_SPECIAL_TERMS == 'no') {
            quoteAnswers.multi_declaration_1_b = 'no';
        }

        window.$.each(quoteAnswers, (i, e) => {
            this.set(i, e);
        });

        if (quoteAnswers['ins_address_postcode'] != null && quoteAnswers['ins_address_postcode'] != undefined) {
            window.setLocalStorageAnswer('cor', quoteAnswers['ins_address_postcode']);
        }

        window.localStorage.setItem('quote', JSON.stringify(quoteQuoteData));
        window.localStorage.setItem('jpk', this.calculateJpkFromLocalStorage());



        window.localStorage.setItem('spk', this.calculateSpkFromLocalStorage());
        window.localStorage.setItem('step1', true);
        this.getQuestions();
    },

    getQuestions() {
        let Questions = require('../Managers/Questions');
        let ProductCover = require ('../Managers/ProductCover');
        let jp = ProductCover.getJourneyPermutation();
       // window.localStorage.setItem('journey_permutation_key', jp);
        
        if (jp > 0) {
            this.coversRequest = $.ajax({
                type: 'POST',
                data: {journey_permutation_key: jp},
                url: Config.api.questions.url

            }).done(function(results) {
                Questions.cache(results.data);
            }).fail(function(){

            });
        }
    },

    getByPath(localStorageKey, path) {
        if (window.uornorb(path)) {
            let chunks = localStorageKey.split('.');
            path = localStorageKey.replace(String(chunks[0]) + '.', '');
            localStorageKey = chunks[0];
        }

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        return objectPath.get(item, path);
    },

    setByPath(path, value) {
        let chunks = path.split('.');
        let localStorageKey = chunks[0];
        path = path.replace(String(localStorageKey) + '.', '');

        if (value === '') {
            value = null;
        }

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        if (window.uorn(item)) {
            window.localStorage.setItem(localStorageKey, '{}');
            item = {};
        }
        objectPath.set(item, path, value);
        window.localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    cacheQuoteError: function(error) {
        this.clearQuoteCaches();
        window.localStorage.setItem('quote_error', error);
    },
    clearQuoteCaches: function() {
        window.localStorage.removeItem("quote_error");
        window.localStorage.removeItem("quote");
    },
    hasQuote: function() {
        return (JSON.parse(window.localStorage.getItem('quote')) !== null);
    },
    getQuote: function() {
        return JSON.parse(window.localStorage.getItem('quote'));
    },
    hasErrors: function() {
        return (JSON.parse(window.localStorage.getItem('quote_error')) !== null);
    },
    getErrors: function() {
        return JSON.parse(window.localStorage.getItem('quote_error'));
    },

    getCurrentAnswer: function(key) {
        let a = JSON.parse(window.localStorage.getItem('answers'));

        let found = false;
        for (let i in a) {
            if (a[i].question === key) {
                found = a[i].answer;
            }
        }

        return (found !== false) ? found : null;

    },
    hasAnswer(key) {
        return this.hasAnswers(key);
    },
    hasAnswers(...keys) {

        let allMatched = true;
        keys.map(function(key) {
            let t = this.getCurrentAnswer(key);
            if (t === null || t === '') {
                allMatched = false;
            }
        }, this);
        return allMatched;
    },
    setQuoteStatus(status) {
        this.set('quote_status', status);
    },
    generateQuote(apiMethod, apiUrl) {
        let answers = JSON.parse(window.localStorage.getItem("answers"));
        let postAnswers = new Array();
        let obj = {};

        answers.map(function(answer) {
            obj[answer.question] = answer.answer;
        }, this);

        // at the point we generate a quote, if we have previous claims, put them into the array
        let previous_claims = window.localStorage.getItem('previous_claims');
        if (undefined != previous_claims) {
            obj.previous_claims = previous_claims;
        }

        if(obj["is_not_override_dsi"]=="yes" && obj["building_type"]=="Flat"){
            obj.building_value = "2000000";
        }

        postAnswers.push(obj);

        return $.ajax({
            type: "post",
            data: postAnswers[0],
            url: apiUrl
        });

    },
    loadQuote(apiMethod, apiUrl, id)  {
        return $.ajax({
            type: apiMethod,
            url: apiUrl+id
        });
    },

    /**
     * read the various "need_" keys from local storage, and use them
     * to calculate the journey permutation key that the quote is for
     * @return {int} the calculated journey permutation key
     */
    calculateJpkFromLocalStorage : function() {
        let _this = this;
        let jpk = '';
        let need_building_insurance         = (_this.getCurrentAnswer('need_building_insurance') !== null) ? _this.getCurrentAnswer('need_building_insurance') : 'no' ;
        let need_contents_insurance         = (_this.getCurrentAnswer('need_contents_insurance') !== null) ? _this.getCurrentAnswer('need_contents_insurance') : 'no' ;
        let need_prestige_rent_guarantee    = (_this.getCurrentAnswer('need_prestige_rent_guarantee') !== null) ? _this.getCurrentAnswer('need_prestige_rent_guarantee') : 'no' ;
        let need_legal_expenses             = (_this.getCurrentAnswer('need_legal_expenses') !== null) ? _this.getCurrentAnswer('need_legal_expenses') : 'no' ;

        // BUILDINGS AND CONTENTS
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'no') {
                jpk = 2;
        }
        // BUILDINGS
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'no'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'no') {
                jpk = 4;
        }
        // CONTENTS
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'no') {
                jpk = 8;
        }
        // RGL
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'no'
            && need_prestige_rent_guarantee == 'yes'
            && need_legal_expenses == 'yes') {
                jpk = 16;
        }
        // LEGAL
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'no'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'yes') {
                jpk = 32;
        }
        // RGL + BC
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'yes'
            && need_legal_expenses == 'yes') {
                jpk = 18;
        }
        // RGL + B
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'no'
            && need_prestige_rent_guarantee == 'yes'
            && need_legal_expenses == 'yes') {
                jpk = 20;
        }
        // RGL + C
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'yes'
            && need_legal_expenses == 'yes') {
                jpk = 24;
        }
        // L + BC
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'yes') {
                jpk = 34;
        }
        // L + B
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'no'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'yes') {
                jpk = 36;
        }
        // L + C
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'yes'
            && need_prestige_rent_guarantee == 'no'
            && need_legal_expenses == 'yes') {
                jpk = 40;
        }

        return jpk;
    },

    /**
     * read the various "need_" keys from local storage, and use them
     * to calculate the secondary journey permutation key that the quote is for
     * @return {int} the calculated secondary journey permutation key
     */
    calculateSpkFromLocalStorage : function() {
        let _this = this;

        let jpk = this.calculateJpkFromLocalStorage();

        if (jpk == 2 || jpk == 4 ||jpk == 8) {
            return 0;
        }

        let spk = '';
        let need_building_insurance = (_this.getCurrentAnswer('need_building_insurance') !== null) ? _this.getCurrentAnswer('need_building_insurance') : 'no' ;
        let need_contents_insurance = (_this.getCurrentAnswer('need_contents_insurance') !== null) ? _this.getCurrentAnswer('need_contents_insurance') : 'no' ;

        // BUILDINGS AND CONTENTS
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'yes') {
                spk = 2;
        }
        // BUILDINGS
        if (need_building_insurance == 'yes'
            && need_contents_insurance == 'no') {
                spk = 4;
        }
        // CONTENTS
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'yes') {
                spk = 8;
        }

        // NO SPK NEEDED - set to 0 so added up total is correct
        if (need_building_insurance == 'no'
            && need_contents_insurance == 'no') {
                spk = 0;
        }

        return spk;
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Quote.js
 **/